import React, { Fragment } from 'react';
import './tips.scss';

export interface InterfaceTip {
  image: string;
  breadcrumbs: string;
  href: string;
  title: string;
  linkText: string;
  moreItemsText: string;
  list: Array<string>;
}

export default function Tip(props: any) {
    const {image, breadcrumbs, href, title, linkText, moreItemsText, list} = props;

    let listTips = (
    <ul>
        {list.map((item: string, index: number) => (
        <li key={index}>{item}</li>
        ))}
    </ul>
    );

    let moreItems = (moreItemsText?.length > 0) ? <a className="tip-link-more-items" href={href} target="_blank" rel="noopener noreferrer">{moreItemsText}</a> : <Fragment></Fragment>

    return (
    <div className="tip-container">
        <div className="row">
            <div className="col-md-9">
                <div className="tip-title">{title}</div>
                {listTips}
                {moreItems}
            </div>
            <div className="col-md-3">
                <a className="tip-image" href={href} target="_blank" rel="noopener noreferrer">
                    <div className="img-container">
                        <img src={image} alt="" height="188" width="359" style={{"marginLeft": "-32px", "marginRight": "-43px"}}></img>
                    </div>
                </a>
            </div>
            <a className="tip-link" href={href} target="_blank" rel="noopener noreferrer">
            <span className="tip-breadcrumb">
                {breadcrumbs}
            </span>
            <div className="tip-link-text">
                {linkText}
            </div>
            </a>
        </div>
    </div>
    );
}
